import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";

export const hpItems = [
  {
    title: "Generera prov & dela med elever",
    description:
      "Generera prov i samma format som högskoleprov med möjligheten att kontrollera för vilken årskurs svårighetsgraden ska anpassas till.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/hp-skapa-prov.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/hp-skapa-prov.png",
    icon: "School",
    path: "/app/hp",
    listItems: [
      {
        text: "Frågetyper såsom läs- och ordförståelse, meningsbyggnad & matematik",
      },
      {
        text: "Välj tema och antal frågor för varje frågetyp",
      },
      {
        text: "Anpassa svårighetsgraden genom att välja årskurs",
      },
      {
        text: "Stöd för över 50 språk",
      },
      {
        text: "Eleverna går in på studera.ai/elev och skriver in provnyckeln",
      },
    ],
  },
];

export const podcastItems = [
  {
    title: "Generera podcast",
    description:
      "Generera en podcast baserat på valfritt dokument, bild, URL eller egna instruktioner. Ladda ned eller dela.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/podcast-generera-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/podcast-generera.png",
    icon: "Mic",
    path: "/app/podcast",

    listItems: [
      { text: "Generera en podcast om vilket ämne du vill" },
      {
        text: "Basera podcasten på valfritt dokument, bild, URL eller egna instruktioner",
      },
      {
        text: "Dela podcasten med vänner, ladda ned mp3-filen eller dela en länk",
      },
      {
        text: "Transkriptionen sparas så man kan läsa medan man lyssnar",
      },
      {
        text: "Generera din podcast på 50 olika språk",
      },
    ],
  },

  {
    title: "Dela podcast",
    description:
      "Möjlighet att dela podcasten via en delbar länk eller till dina elever eller vänner.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/podcast-dela-med-vanner.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/podcast-dela-med-vanner.png",
    icon: "Share",

    listItems: [
      {
        text: "Dela podcasten med dina elever eller vänner, enkelt och smidigt",
      },
      {
        text: "Dela podcasten via en delbar länk, åtkomlig för alla",
      },
    ],
  },
];

export const bibleItems = [
  {
    title: "Chatta med Bibeln",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibeln-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibeln-2.png",
    icon: "LibraryBooks",

    listItems: [
      {
        text: "Interaktiv dialog med bibeln innehåll – ställ frågor och få svar som om du chattar direkt med bibeln",
      },
      {
        text: "Avancerad semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Vår AI förstår bibeltextens djupare innebörd och mening",
      },
      // {
      //   text: "Utforska komplexa ämnen genom att ställa följdfrågor – precis som i en verklig dialog",
      // },
      {
        text: "Upptäck insikter och information som annars kan vara svåra att hitta genom traditionell läsning",
      },
    ],
  },

  {
    title: "Anpassa hur assistenten svarar",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bibel-anpassa-prompt.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bibel-anpassa-prompt.png",
    icon: "Edit",

    listItems: [
      {
        text: "Redigera precis hur du vill att assistenten svarar",
      },
      {
        text: "Beskriv vilket format du vill ha, längden på svar, komplexitetsnivå etc.",
      },
      {
        text: "Total kontroll",
      },
    ],
  },

  {
    title: "Exportera innehåll",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibel-tabell.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibel-tabell.png",
    icon: "Download",

    listItems: [
      {
        text: "Fråga AI-modellen efter ett svar i tabell-format",
      },
      {
        text: "Exportera som Word- eller PDF-fil",
      },
      {
        text: "Redigera i efterhand vid behov",
      },
    ],
  },

  {
    title: "Spara meddelanden i eget arkiv",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibel-spara.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibel-spara.png",
    icon: "SaveAs",

    listItems: [
      {
        text: "Du kan när som helst spara viktiga meddelanden",
      },
      {
        text: "Tillgång till eget arkiv",
      },
      {
        text: "Utmärkt för att samla meddelanden till ett visst projekt",
      },
    ],
  },
];

export const imageItems = [
  {
    title: "Generera bilder med AI",
    description:
      "Beskriv vad du vill generera och få en AI-genererad bild som sparas i ditt eget arkiv, eller ladda ned/skriv ut direkt.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/generera-bilder.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/generera-bilder.png",
    icon: "AutoFixHigh",

    listItems: [
      { text: "Beskriv vad du vill generera för bild" },
      { text: "Bilden sparas i ditt eget arkiv" },
      { text: "Ladda ned bilden och använd hur du vill" },
      { text: "Möjlighet att skriva ut bilden direkt" },
    ],
  },
  {
    title: "Bildanalys",
    description:
      "Ladda upp valfri bild och få en analys. Populärt bland elever & studenter som tar bilder på matematiska formler, eller svåra förklaringar, och får en förenklad förklaring.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bildanalys.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bildanalys.png",
    icon: "AutoFixHigh",

    listItems: [
      { text: "Ladda upp valfri bild och få en analys" },
      {
        text: "Populärt bland elever & studenter som tar bilder på matematiska formler och får en förklaring",
      },
      {
        text: "Möjlighet att själv instruera vad som ska analyseras i bilden och hur informationen ska presenteras",
      },
    ],
  },

  {
    title: "Bildbanken",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bildbanken.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bildbanken.png",
    icon: "Dashboard",

    listItems: [
      { text: "Tillgång till ett arkiv med över 10000 AI-genererade bilder" },
      { text: "Filtrera på olika kategorier" },
      { text: "Ladda ned valfria bilder och använd helt fritt" },
      { text: "Skriv ut fylla-i-bilder" },
    ],
  },
];

export const lessonPlanItems = [
  {
    title: "Generera lektionsplanering & skriv ut",
    description:
      "Generera en lektionsplanering på 1 minut och redigera, skriv ut, dela med elever/kollegor eller spara i din egen lektionsbank.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-lektionsplanering-3.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-lektionsplanering-3.png",
    icon: "AutoFixHigh",
    path: "/app/lektioner/lektionsplan",
    listItems: [
      { text: "Generera en lektionsplanering om exakt vad du vill" },
      { text: "Välj årskurs och längd på lektionen" },
      { text: "Redigera vid behov" },
      { text: "Skriv ut eller spara i din egen lektionsbank" },
      { text: "Gå tillbaka när som helst för att göra ändringar" },
    ],
  },

  // {
  //   title: "Välj mellan olika underlag",
  //   description: "",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
  //   icon: "HighlightAlt",
  //   listItems: [
  //     { text: "Skriv in egna instruktioner" },
  //     { text: "Klistra in valfri text" },
  //     {
  //       text: "Ladda upp valfritt studiematerial",
  //     },
  //     { text: "Hämta innehåll från valfri webbaddress" },
  //     {
  //       text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
  //     },
  //     { text: "Samt många fler alterantiv" },
  //   ],
  // },

  {
    title: "Redigera lektionsplanering",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/redigera-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/redigera-lektionsplanering.png",
    icon: "Edit",
    listItems: [
      { text: "Redigera lektionsplaneringen efter behov" },
      { text: "Ta bort delar som inte behövs" },
      { text: "Spara ändringarna" },
    ],
  },

  {
    title: "Spara i egen lektionsbank",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/spara-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/spara-lektionsplanering.png",
    icon: "SaveAs",
    listItems: [
      { text: "Spara lektionsplaneringar i din egen lektionsbank" },
      { text: "Kategorisera utifrån ämne och årskurs" },
      {
        text: "Möjlighet att gå tillbaka när som helst för att göra ändringar",
      },
      { text: "Redigera en gammal lektionsplanering när du vill" },
    ],
  },

  {
    title: "Skriv ut lektionsplanering",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/skriv-ut-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/skriv-ut-lektionsplanering.png",
    icon: "Print",
    listItems: [
      { text: "Skriv ut lektionsplaneringen" },
      {
        text: "Märker du att nåt blev fel — gå tillbaka och redigera och skriv ut igen",
      },
      {
        text: "Möjlighet att skriva ut gamla lektionsplaneringar från din lektionsbank när som helst",
      },
    ],
  },
];

export const lessonItems = [
  {
    title: "Generera lektion & dela med elever",
    description:
      "Välj mellan 30 olika lektionstyper, allt från läsförståelse till tidslinjer, tankekartor och Jeopardy.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-generera-och-dela-med-elever-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-generera-och-dela-med-elever-2.png",
    icon: "AutoFixHigh",
    path: "/app/lektioner",
    listItems: [
      {
        text: "Generera lektioner baserat på eget underlag eller instruktioner",
      },
      { text: "Gör eventuella redigeringar vid behov" },
      { text: "Dela med dina elever" },
      { text: "Eleverna får en avisering och kan enkelt påbörja lektionen" },
    ],
  },

  // {
  //   title: "Generera lektioner",
  //   description:
  //     "Se hur du enkelt genererar en lektion med tillhörande bilder. Sparar i din egen lektionsbank och skriver ut.",
  //   videoUrl:
  //     "https://sportkuriren.se/wp-content/uploads/generera-lektioner-2.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/generera-lektioner.png",
  //   icon: "AutoFixHigh",
  //   listItems: [
  //     { text: "30 lektionstyper (läsförståelse. escape rooms m.fl.)" },
  //     { text: "Generera lektioner från valfritt underlag" },
  //     { text: "Redigera material efter behov" },
  //     { text: "Generera passande bilder" },
  //     { text: "Dela med elever" },
  //     { text: "Spara i lektionsbank eller skriv ut" },
  //   ],
  // },

  // {
  //   title: "Välj mellan olika underlag",
  //   description: "",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
  //   icon: "HighlightAlt",
  //   listItems: [
  //     { text: "Skriv in egna instruktioner" },
  //     { text: "Klistra in valfri text" },
  //     {
  //       text: "Ladda upp valfritt studiematerial",
  //     },
  //     { text: "Hämta innehåll från valfri webbaddress" },
  //     {
  //       text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
  //     },
  //     { text: "Samt många fler alterantiv" },
  //   ],
  // },

  {
    title: "Generera övningar",
    description:
      "Låt vår AI generera övningar eller uppgifter baserat på lektionsinnehållet.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-lagg-till-ovningar.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-lagg-till-ovningar.png",
    icon: "Spellcheck",
    listItems: [
      { text: "Komplettera lektionen genom att generera övningar" },
      { text: "Välj mellan 6 olika övningstyper" },
      { text: "Redigera vid behov" },
      { text: "Lägg till övningarna i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
    ],
  },

  {
    title: "Generera frågor",
    description:
      "Låt vår AI generera frågor baserat på lektionsinnehållet, t.ex. skriftligt prov eller flervalsfrågor.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-lagg-till-quiz.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-lagg-till-quiz.png",
    icon: "Psychology",
    listItems: [
      { text: "Komplettera lektionen genom att generera frågor/quiz/prov" },
      {
        text: "Välj mellan 4 olika frågetyper (flervalsfrågor, sant/falskt m.fl.)",
      },
      { text: "Redigera eller lägg till frågor vid behov" },
      { text: "Lägg till frågorna i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
      { text: "Tillgång till facit på separat sida vid utskrift" },
    ],
  },

  {
    title: "Generera tidslinje",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-tidslinje.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-tidslinje.png",
    icon: "Timeline",
    listItems: [
      { text: "Komplettera lektionen genom att generera en tidslinje" },
      {
        text: "Välj antal händelser och språk för tidslinjen",
      },
      {
        text: "Redigera händelserna, dess ordning, bilder eller och text vid behov",
      },
      { text: "Lägg till tidslinjen i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
    ],
  },

  {
    title: "Redigera, lägg till eller ta bort",
    description:
      "Allt som genereras kan redigeras och anpassas utifrån dina behov.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-redigera.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-redigera.png",
    icon: "Edit",
    listItems: [
      { text: "Allt som genereras kan redigeras" },
      { text: "Anpassa innehållet utifrån elevens behov" },
      {
        text: "Glöm inte att spara lektionen i din lektionsbank efter ändringarna är gjorda",
      },
    ],
  },

  {
    title: "Spara i din egen lektionsbank",
    description:
      "Du kan enkelt spara dina egna eller andras lektioner i din egen lektionsbank och gå tillbaka och redigera när som helst.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/lektioner-spara.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-spara.png",
    icon: "SaveAs",
    listItems: [
      { text: "Tillgång till personligt arkiv" },
      { text: "Kategorisera dina lektioner utifrån ämne och årskurs" },
      { text: "Gå tillbaka och redigera tidigare lektioner när som helst" },
      { text: "Radera lektioner när du vill" },
    ],
  },
  {
    title: "Översätt",
    description:
      "Översätt ditt lektionsmaterial till olika språk med ett enkelt knapptryck.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-oversatt.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-oversatt.png",
    icon: "Translate",
    listItems: [
      { text: "Översätt lektioner på över 50 språk" },
      { text: "Utmärkt för elever som inte behärskar svenska fullt ut" },
      { text: "Alla elever känner sig inkluderade" },
    ],
  },
  {
    title: "Skriv ut",
    description:
      "Om du inte vill dela lektionen via Studera.ai kan du helt enkelt skriva ut den.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-skriv-ut.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-skriv-ut.png",
    icon: "Print",
    listItems: [],
  },

  {
    title: "Dela via elevrum (konto krävs)",
    description:
      "Dela dina lektioner med eleverna som får en notis och kan enkelt gå till lektionen.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-dela-via-elevrum.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-dela-via-elevrum.png",
    icon: "Share",
    listItems: [
      { text: "Dela lektioner med alla eller några elever i ett elevrum" },
      { text: "Eleven får en avisering när lektionen är delad" },
    ],
  },

  {
    title: "Dela via länk (inget konto krävs)",
    description:
      "Dela dina lektioner med elever eller kollegor genom en delbar länk. Inget elevkonto krävs.'.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-dela-via-lank.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-dela-via-lank.png",
    icon: "Link",
    listItems: [
      { text: "Välj en av dina sparade lektioner" },
      { text: "Klicka på dela länk" },
      { text: "Kopiera länken och dela den via Google Classroom eller e-post" },
      { text: "Inget konto för elever krävs" },
    ],
  },
];

export const quizItems = [
  {
    title: "Generera quiz & dela med elever",
    description:
      "Generera frågor, redigera, lägg till eller ta bort. Dela med elever och se deras svar i realtid.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-generera-fragor-6.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-generera-fragor-4.png",
    icon: "AutoFixHigh",
    path: "/app/quiz",
    listItems: [
      { text: "Generera frågor med valfria instruktioner" },
      { text: "Redigera frågor och svar utifrån egna behov" },
      { text: "Kategorisera quizzet utifrån ämne och årskurs" },
      { text: "Spara i ditt eget arkiv" },
      { text: "Gå tillbaka och redigera när som helst" },
      { text: "Dela med elever" },
      { text: "Se elevernas resultat i realtid" },
    ],
  },

  // {
  //   title: "Generera quiz & skriv ut",
  //   description:
  //     "Generera quiz med valfri frågetyp, redigera eller lägg till frågor vid behov och skriv ut. ",
  //   videoUrl:
  //     "https://sportkuriren.se/wp-content/uploads/quiz-generera-fragor-och-skriv-ut.mp4",
  //   poster:
  //     "https://sportkuriren.se/wp-content/uploads/quiz-generera-fragor-4.png",
  //   icon: "Print",
  //   path: "/app/quiz",
  //   listItems: [
  //     { text: "Generera frågor med valfria instruktioner" },
  //     { text: "Redigera frågor och svar utifrån egna behov" },
  //     { text: "Lägg till eller ta bort frågor" },
  //     { text: "Skriv ut" },
  //     { text: "Gå tillbaka och redigera när som helst" },
  //   ],
  // },
  // {
  //   title: "Välj mellan olika underlag",
  //   description: "",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
  //   icon: "HighlightAlt",
  //   listItems: [
  //     { text: "Skriv in egna instruktioner" },
  //     { text: "Klistra in valfri text" },
  //     {
  //       text: "Ladda upp valfritt studiematerial",
  //     },
  //     { text: "Hämta innehåll från valfri webbaddress" },
  //     {
  //       text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
  //     },
  //     { text: "Samt många fler alterantiv" },
  //   ],
  // },
  {
    title: "Dela via provnyckel (inget konto)",
    hide: true,
    description:
      "Eleverna går in på studera.ai/elev och skriver in provnyckeln.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-via-provnyckel-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-via-provnyckel-3.png",
    icon: "Key",

    listItems: [
      { text: "Välj ett av dina egna quiz och klicka på visa provnyckel" },
      {
        text: "Låt eleverna gå till studera.ai/elev och skriv in namn och provnyckel",
      },
      {
        text: 'Klicka på "Övervaka resultat" för att se elevernas svar i realtid',
      },
      { text: "Inget konto för elever krävs" },
    ],
  },

  {
    title: "Dela via elevrum (konto krävs)",
    hide: true,
    description:
      "Eleverna får en notis när du delar ett quiz via ett av dina elevrum.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-via-elevrum.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-via-elevrum-2.png",
    icon: "Share",

    listItems: [
      { text: "Välj ett av dina egna quiz och klicka på dela med elever" },
      {
        text: "Eleverna får en avisering och och påbörjar quizzet",
      },
      {
        text: 'Klicka på "Övervaka resultat" för att se elevernas svar i realtid',
      },
      { text: "Konto för elever krävs" },
    ],
  },

  {
    title: "Generera quiz från bild",
    hide: true,
    description:
      "Eleverna får en notis när du delar ett quiz via ett av dina elevrum.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-fran-bild.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-fran-bild.png",
    icon: "Share",

    listItems: [],
  },

  {
    title: "Redigera quiz",
    description:
      "Generera om frågor med AI, eller lägg till nya tills du har ett quiz du är nöjd med.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-redigera-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-redigera-2.png",
    icon: "Edit",
    listItems: [
      { text: "Redigera valfritt quiz enkelt och smidigt" },
      { text: "Lägg till eller ta bort frågor" },
      { text: "Anpassa svarsalterantiv och ledtrådar" },
      { text: "Spara ändringarna" },
    ],
  },

  // {
  //   title: "Skriv ut skriftligt prov",
  //   description:
  //     "Generera ett quiz och välj frågetypen 'Prov' och skriv ut ett färdigt test på 30 sekunder. Redigera frågorna på sättet du vill.",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/skapa-prov.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/skapa-prov-poster.png",
  //   icon: "Print",
  //   listItems: [
  //     { text: "Generera quiz baserat på valfritt underlag" },
  //     { text: "Redigera frågor och svar vid behov" },
  //     { text: "Skriv ut quizzet med facit på separat sida" },
  //     { text: "Dela ut till eleverna" },
  //   ],
  // },

  {
    title: "Skriftliga prov",
    description:
      "Generera ett quiz som kräver att eleven skriver in svaret själv. Elever får en analys av deras svar samt förbättringsförslag.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-skriftligt-prov.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-skriftligt-prov.png",
    icon: "Psychology",
    listItems: [
      { text: "Generera quiz som kräver resonerande svar" },
      { text: "Populärt bland elever & studenter som övning inför prov" },
      {
        text: "AI:n bedömer varje svar och ger utförlig förklaring för varje svar",
      },
      { text: "Välj bland 3 ljudeffekter för att simulera en provmiljö" },
      { text: "Möjlighet att som lärare se resultaten i realtid" },
    ],
  },

  {
    title: "Skriv ut quiz",
    description:
      "Skriv ut quizet så eleverna får kryssa i rätt svarsalternativ eller själv skriva svaret, beroende på vilken frågetyp du väljer.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-skriv-ut.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-skriv-ut.png",
    icon: "Print",
    listItems: [],
  },

  {
    title: "Öva under tidspress med timer",
    description: "Ange antal sekunder för varje fråga.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-timer-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-timer-2.png",
    icon: "Timer",
    listItems: [
      { text: "Simulera en provmijö genom att aktivera en timer" },
      { text: "Välj hur många sekunder man ska få för varje fråga" },
      { text: "Utmärkt för att öva inför en provsituation" },
    ],
  },
  {
    title: "Simulera prov med bakgrundsljud",
    description:
      "Öva med olika störningsljud som klotter, väggklocka eller cafésorl.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-ljudeffekt-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-ljudeffekt-2.png",
    icon: "VolumeUp",
    listItems: [
      { text: "Öva på provet genom att aktivera bakgrundsljud" },
      {
        text: "Välj mellan 3 olika ljudeffekter: väggklocka, cafésorl och klotter",
      },
      { text: "Perfekt för att öva på att resonera med bakgrundsljud" },
    ],
  },
  {
    title: "Nutidsfrågor (1X2-frågor)",
    description:
      "Generera klassiska nutidsfrågor i ett 1X2-format om precis vad du vill. Redigera frågorna för att passa veckans händelser eller välj frågor från förr.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-4.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-4.png",
    icon: "Newspaper",
    path: "/app/quiz",
    listItems: [
      { text: "Generera klassiska nutidsfrågor i ett 1X2-frågor" },
      { text: "Inkluderar en svarstalong" },
      {
        text: "Redigera frågor för att passa veckans händelser eller välj frågor från förr",
      },
      { text: "Skriv ut eller spara din din egen quiz-bank" },
    ],
  },

  // {
  //   title: "Generera interaktivt quiz",
  //   description:
  //     "Generera interaktivt quiz som är populärt bland elever och studenter. Se resultat och hur du hittar dina genererade quiz under 'Mitt innehåll' varifrån man kan dela, redigera eller radera.",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/generera-quiz-2.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/generera-quiz-2.png",
  //   icon: "Gamepad",
  //   listItems: [
  //     { text: "Generera interaktivt quiz baserat på valfritt underlag" },
  //     { text: "Utmärkt för elever & studenter som vill öva inför ett prov" },
  //     {
  //       text: "Välj mella flera frågetyper (prov, flervalsfrågor etc.)",
  //     },
  //     { text: "Tillgång till eget arkiv" },
  //     { text: "Graf med resultat över tid" },
  //   ],
  // },

  {
    title: "Diskutera med AI",
    description:
      "Du kan närsomhelst diksutera med AI beträffande frågan för att öka din förståelse.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-fraga-ai.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-fraga-ai.png",
    icon: "ChatBubbleOutline",
    listItems: [
      { text: "Diskutera med vår AI-modell för att lösa frågan" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Ledtrådar från AI",
    description:
      "Få en eller flera ledtrådar som stegvis leder dig fram till förståelse och en lösning.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-ledtrad.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-ledtrad.png",
    icon: "Lightbulb",
    listItems: [
      { text: "Få en ledtråd från vår AI-modell för att lösa frågan" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },
];

export const flashcardItems = [
  {
    title: "Generera flashcards & dela med elever",
    description:
      "Generera pedagogiska flashcards som du enkelt kan redigera och sedan dela med elever eller vänner.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-generera-6.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/flashcards-generera-7.png",
    icon: "AutoFixHigh",
    path: "/app/flashcards",
    listItems: [
      {
        text: "Generera flashcards baserat på valfritt underlag eller instruktioner",
      },
      {
        text: "Redigera, ta bort eller lägg till bilder för varje flashcard (utmärkt för visuellt lärande)",
      },
      { text: "Spara i ditt eget arkiv" },
      { text: "Gå tillbaka och redigera dina flashcards när du vill" },
      { text: "Möjlighet att dela med elever" },
    ],
  },

  // {
  //   title: "Välj mellan olika underlag",
  //   description: "",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
  //   icon: "HighlightAlt",
  //   listItems: [
  //     { text: "Skriv in egna instruktioner" },
  //     { text: "Klistra in valfri text" },
  //     {
  //       text: "Ladda upp valfritt studiematerial",
  //     },
  //     { text: "Hämta innehåll från valfri webbaddress" },
  //     {
  //       text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
  //     },
  //     { text: "Samt många fler alterantiv" },
  //   ],
  // },

  {
    title: "Redigera flashcards",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/redigera-flashcards.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/redigera-flashcards.png",
    icon: "Edit",

    listItems: [
      { text: "Gå till Mina flashcards" },
      { text: "Klicka på Redigera, gör dina ändringar och spara" },
      {
        text: "Utmärkt för att göra ändringar i efterhand utan att behöva generera nya",
      },
      { text: "Dela med elever ånyo" },
    ],
  },

  {
    title: "Dela via elevrum (konto krävs)",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/dela-flashcards-via-elevrum.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/dela-flashcards-via-elevrum.png",
    icon: "Share",

    listItems: [
      {
        text: "Generera flashcards baserat på valfritt underlag eller instruktioner",
      },
      { text: "Redigera vid behov" },
      { text: "Lägg till bilder för visuellt lärande vid behov" },
      { text: "Dela via elevrum" },
      { text: "Eleverna får en avisering och kan börja öva direkt" },
      {
        text: "Eleverna kan när som helst klicka på Mina flashcards och öva vid senare tillfälle",
      },
    ],
  },

  {
    title: "Generera interaktiva flashcards",
    description:
      "Generera interaktiva flashcards. Redigera och lägg till bilder för varje flashcard om du vill. Öva när som helst.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-interaktiva-flashcards-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-interaktiva-flashcards-2.png",
    icon: "Gamepad",

    listItems: [
      {
        text: "Generera flashcards baserat på valfritt underlag eller instruktioner",
      },
      {
        text: "Redigera vid behov",
      },
      {
        text: "Lägg till bilder för framsida eller baksida om du föredrar visuellt lärande",
      },
      {
        text: "Bedöm svårighetsgraden för varje flashcard med tangentbordsgenvägar (1, 2, 3, 4 & mellanslag)",
      },
      {
        text: "Sparas i Mina flashcards så du när som helst kan öva igen",
      },
    ],
  },

  {
    title: "Diskutera med AI",
    description:
      "Du kan närsomhelst diksutera med AI beträffande dina flashcards för att öka din förståelse.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-fraga-ai.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/flashcards-fraga-ai.png",
    icon: "ChatBubbleOutline",
    listItems: [
      { text: "Diskutera med vår AI-modell" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Ledtrådar från AI",
    description:
      "Få en eller flera ledtrådar som stegvis leder dig fram till förståelse och en lösning.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-ledtrad.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/flashcards-ledtrad.png",
    icon: "Lightbulb",
    listItems: [
      { text: "Få en ledtråd från vår AI-modell" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },
];

export const textLabbetItems = [
  {
    title: "Hur textlabbet fungerar",
    description:
      "Se hur du kan manipulera vilken text som helst. Analysera, kritisera, omstrukturera, översätta samt 30 andra alterantiv.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/textlabbet.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/textlabbet-poster.png",
    icon: "AutoFixHigh",

    listItems: [
      { text: "Klistra in eller ladda upp din text" },
      { text: "Be textlabbet formulera om den utifrån egna önskningar" },
      { text: "Exportera som Word eller PDF" },
      { text: "Perfekt när man snabbt behöver formulera om ett stycke" },
    ],
  },
];

export const gradingItems = [
  {
    title: "Bedöm elevtexter",
    description:
      "Bedöm hela klassens texter samtidigt på några få minuter. Få detaljerad bedömning och förbättringsförslag.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-ny-bedomning-6.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomning-ny-bedomning-2.png",
    icon: "AutoFixHigh",
    path: "/app/uppsats/ny",
    listItems: [
      { text: "Bedöm valfri text objekivt och konsekvent" },
      { text: "Välj bland fördefinierade bedömningsmatriser eller egna" },
      { text: "Generera egna bedömningsmatriser" },
      { text: "Möjlighet att redigera omdömen" },
      { text: "Resultattavla över elevomdömen" },
    ],
  },

  {
    title: "Generera bedömningsmatris",
    description:
      "Generera en helt egen matris baserat på uppgiften och använd matrisen i bedömningen.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomningsmatris-generera-med-ai-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomningsmatris-generera-med-ai-2.png",
    icon: "TableChart",
    listItems: [
      { text: "Bedöm texter baserat på egenskapade bedömningsmatriser" },
      { text: "Redigera matriser utifrån behov" },
      { text: "Dela matriser med andra lärare" },
      { text: "Tillgång till eget arkiv" },
    ],
  },

  {
    title: "Dela matris med kollegor",
    description:
      "Se hur du enkelt kan dela en av dina bedömningsmatriser med dina kollegor, så de också kan ta nytta av den för olika syften.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-dela-matris-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomning-dela-matris-2.png",
    icon: "Share",
    listItems: [
      { text: "Dela valfri matris som du tycker är extra bra med en kollega" },
    ],
  },

  {
    title: "Resultattavla för varje klass",
    description:
      "Få en tydlig översikt över klassens resultat. Se genomsnittliga övergripande betyg samt poäng för varje kriterium i bedömningsmatrisen.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-resultattavla-snabb-3.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomning-resultattavla.png",
    icon: "SportsScore",
    listItems: [
      { text: "Tydlig översikt över klassens resultat" },
      { text: "Genomsnittliga övergripande betyg" },
      { text: "Se poäng för varje kriterium i bedömningsmatrisen" },
      { text: "Klar betygsfördelning" },
    ],
  },

  {
    title: "Exportera bedömningar",
    description:
      "Exportera en eller flera bedömningar samtidigt. Enkelt och smidigt.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-exportera-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomning-exportera.png",
    icon: "Assignment",
    listItems: [
      { text: "Exportera en eller flera bedömningar samtidigt" },
      { text: "Exportera som Word- eller PDF-dokument" },
      { text: "Redigera omdömet innan exportering vid behov" },
    ],
  },

  {
    title: "Skriv ut bedömning",
    description: "Skriv ut valfri bedömning på nolltid.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-skriv-ut-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bedomning-skriv-ut.png",
    icon: "Print",
    listItems: [
      { text: "Skriv ut valfri bedömning" },
      { text: "Redigera omdömet innan utskrivning vid behov" },
    ],
  },
];

export const powerpointItems = [
  {
    title: "Generera PowerPoint",
    description: "Se hur du genererar en PowerPoint med tillhörande bilder.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-powerpoint-3.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/powerpoint-poster.png",
    icon: "AutoFixHigh",
    path: "/app/generera-powerpoint",
    listItems: [
      {
        text: "Generera en PowerPoint utifrån valfritt ämne eller underlag",
      },
      {
        text: "Redigera text vid behov",
      },
      {
        text: "Lägg till egna eller AI-genererade bilder",
      },
      {
        text: "Exportera PowerPoint",
      },
      {
        text: "Spara i ditt eget arkiv och redigera när som helst",
      },
    ],
  },

  // {
  //   title: "Välj mellan olika underlag",
  //   description: "",
  //   videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
  //   poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
  //   icon: "HighlightAlt",
  //   listItems: [
  //     { text: "Skriv in egna instruktioner" },
  //     { text: "Klistra in valfri text" },
  //     {
  //       text: "Ladda upp valfritt studiematerial",
  //     },
  //     { text: "Hämta innehåll från valfri webbaddress" },
  //     {
  //       text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
  //     },
  //     { text: "Samt många fler alterantiv" },
  //   ],
  // },
];

export const assistentItems = [
  {
    title: "Träna din egen AI-assistent",
    description:
      "Träna din egen AI-assistent baserat på valfritt underlag. Ladda upp eller klistra in ditt material och få tillgång till en assistent som använder avancerad semantisk förståelse för att tolka både ditt material och dina frågor. ",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/assistent-trana.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-trana.png",
    icon: "AutoFixHigh",
    path: "/app/larare",
    listItems: [
      {
        text: "Definiera vilket material assistenten ska tränas på",
      },
      {
        text: "När du ställer en fråga genomförs en semantisk sökning som identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Assistenten analyserar sedan texten och formulerar ett svar som är direkt baserat på kunskapsbasen",
      },
      { text: "Tillgång till historik över ens chattar" },
      { text: "Möjlighet att spara meddelanden" },
    ],
  },
  {
    title: "Skapa en AI-assistent & dela med elever",
    description:
      "Se hur du skapar en AI-assistent, anpassar hur den ska svara & dela med elever",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/assistenter-skapa-ai-assistent-och-dela-med-elever.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/assistenter-skapa-ai-assistent-och-dela-med-elever.png",
    icon: "AutoFixHigh",

    listItems: [
      {
        text: "Definiera exakt hur assistenten ska bete sig och vad den får tala om",
      },
      { text: "Dela assisteten med en eller flera elever" },
      { text: "Redigera & finjustera karaktärens egenskaper" },
    ],
  },
  {
    title: "Språk-assistenter",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/assistent-sprak-spanska.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/assistent-sprak-spanska.png",
    icon: "Language",

    listItems: [
      {
        text: "Chatta eller tala med valfri Språk-assistent för att öva på språkfärdigheterna",
      },
      {
        text: "Välj att öva på olika rollspel (t.ex. besök på restaurang, eller boka en taxi)",
      },

      {
        text: "Öva på läsförståelse, verb och mycket mer",
      },
      {
        text: "Få en rapport med förbättringsförslag och felstavningar",
      },

      {
        text: "Möjlighet att dela konversationen",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Exportera, spara, kopiera eller översätt meddelanden",
      },
    ],
  },

  {
    title: "Ämnes-assistenter",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/assistent-matte.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-matte.png",
    icon: "School",

    listItems: [
      {
        text: "Chatta eller tala med valfri Ämnes-assistent inom t.ex. Matematik, Historia & Samhällskunskap",
      },
      {
        text: "Möjlighet att dela konversationen",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Exportera, spara eller kopiera meddelanden",
      },
    ],
  },

  {
    title: "Chatta med böcker",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibeln.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibeln.png",
    icon: "LibraryBooks",

    listItems: [
      {
        text: "Avancerad semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Interaktiv dialog med bokens innehåll – ställ frågor och få svar som om du chattar direkt med boken",
      },

      {
        text: "Alla svar är direkt förankrade i bokens faktiska innehåll",
      },
      {
        text: "Utforska komplexa ämnen genom att ställa följdfrågor – precis som i en verklig dialog",
      },
      {
        text: "Få välgrundade svar inom bokens ämnesområde med direkta kopplingar till originalverket",
      },
      {
        text: "Upptäck insikter och information som annars kan vara svåra att hitta genom traditionell läsning",
      },
    ],
  },

  {
    title: "ChatGPT för lärare",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/assistent-chatgpt.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-chatgpt.png",
    icon: "Chat",

    listItems: [
      {
        text: "Vår egen version av ChatGPT för lärare",
      },
      {
        text: "Välj vilket språk den ska kommunicera med dig på (över 50 språk)",
      },
      {
        text: "Möjlighet att exportera, spara, kopiera & läsa upp meddelanden",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Fördefinierade prompts som t.ex. att skapa begreppslistor & grupparbete",
      },
      {
        text: "Skapa helt egna prompts för att snabba upp ditt arbete",
      },
    ],
  },

  {
    title: "Dela konversation",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/dela-lank-till-assistent.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/dela-lank-till-assistent.png",
    icon: "Link",

    listItems: [
      {
        text: "Dela en konversation via länk snabbt och smidigt",
      },
      {
        text: "Utmärkt för en lärare att se hur eleven har resonerat och uttryckt sig",
      },
      {
        text: "Perfekt för elever som lär sig ett språk, eller ett matematiskt koncept",
      },
    ],
  },
  {
    title: "Skapa en AI-assistent",
    description:
      "Se hur du skapar en AI-assistent och hur man kan dela konversationer med andra.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/skapa-assistent-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-ai-assistent.png",
    icon: "AutoFixHigh",

    listItems: [
      {
        text: "Definiera exakt hur assistenten ska bete sig och vad den får tala om",
      },
      { text: "Redigera & finjustera karaktärens egenskaper direkt i chatten" },
      { text: "Möjlighet att dela en assistent med elever" },
      { text: "Eleven kan sedan dela konversationen med sin lärare" },
      { text: "Tillgång till historik över ens chattar" },
      { text: "Möjlighet att spara meddelanden" },
    ],
  },

  {
    title: "Dela assistent",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/dela-assistent.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/dela-assistent.png",
    icon: "Share",

    listItems: [
      {
        text: "När du skapat en lämplig assistent kan du dela den med elever",
      },
      {
        text: "Utmärkt för elever med annat modersmål än svenska för att få svaren på två språk",
      },
      {
        text: "Eleven kan sedan dela konversationen med läraren om de vill",
      },
    ],
  },
];

export const visionItems = [
  {
    title: "Bildanalys",
    description:
      "Ladda upp valfri bild och få en analys. Populärt bland elever & studenter som tar bilder på matematiska formler, eller svåra förklaringar, och får en förenklad förklaring.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bildanalys.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bildanalys.png",
    icon: "AutoFixHigh",
    listItems: [
      { text: "Ladda upp valfri bild och få en analys" },
      {
        text: "Populärt bland elever & studenter som tar bilder på matematiska formler och får en förklaring",
      },
      {
        text: "Möjlighet att själv instruera vad som ska analyseras i bilden och hur informationen ska presenteras",
      },
    ],
  },
];

export const VideoPlayer = ({
  videoUrl,
  poster,
  controls = false,
  autoPlay = false,
  animationType = "pulse", // Options: pulse, glow, bounce, ripple, spin, color-shift, fade
  autoplayOnScroll = false, // New prop for scroll-based autoplay
  disableClick = false,
  gridDisplay = false,
  horizDisplay = false,
}) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isInViewport, setIsInViewport] = useState(false);
  const playPromiseRef = useRef(null);

  // Handle scroll-based autoplay with debounce
  useEffect(() => {
    if (!autoplayOnScroll) return;

    let timeoutId = null;

    const handleVisibilityChange = (isVisible) => {
      // Clear any pending timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Set a small delay to debounce rapid changes
      timeoutId = setTimeout(() => {
        setIsInViewport(isVisible);
      }, 150); // 150ms debounce
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        handleVisibilityChange(entry.isIntersecting);
      },
      { threshold: 0.8 },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [autoplayOnScroll]);

  // Control video playback based on visibility state
  useEffect(() => {
    if (!videoRef.current || controls) return;

    const safePlay = async () => {
      try {
        if (videoRef.current && videoRef.current.paused) {
          videoRef.current.playbackRate = 1.25;
          playPromiseRef.current = videoRef.current.play();

          // Wait for the play promise to resolve
          if (playPromiseRef.current) {
            await playPromiseRef.current;
            playPromiseRef.current = null;
            setIsPlaying(true);
          }
        }
      } catch (error) {
        console.log("Playback error:", error);
      }
    };

    const safePause = async () => {
      try {
        // Make sure any pending play promise is resolved before pausing
        if (playPromiseRef.current) {
          await playPromiseRef.current;
          playPromiseRef.current = null;
        }

        if (videoRef.current && !videoRef.current.paused) {
          videoRef.current.pause();
          setIsPlaying(false);
        }
      } catch (error) {
        console.log("Pause error:", error);
      }
    };

    if (autoplayOnScroll) {
      if (isInViewport) {
        safePlay();
      } else {
        safePause();
      }
    }
  }, [isInViewport, controls, autoplayOnScroll]);

  // Handle initial autoplay
  useEffect(() => {
    if (autoPlay && videoRef.current) {
      videoRef.current.playbackRate = 1.25;
      const playPromise = videoRef.current.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPlaying(true);
          })
          .catch((error) => {
            // Auto-play was prevented, probably due to browser policy
            console.log("Autoplay prevented:", error);
          });
      }
    }
  }, [autoPlay]);

  const handleClick = async (e) => {
    if (controls) return;
    e.preventDefault();

    if (videoRef.current) {
      try {
        if (videoRef.current.paused) {
          // If paused, try to play
          videoRef.current.playbackRate = 1.25;
          const playPromise = videoRef.current.play();

          if (playPromise !== undefined) {
            playPromiseRef.current = playPromise;
            await playPromise;
            playPromiseRef.current = null;
            setIsPlaying(true);
          }
        } else {
          // If playing, make sure any play promise is resolved before pausing
          if (playPromiseRef.current) {
            await playPromiseRef.current;
            playPromiseRef.current = null;
          }

          videoRef.current.pause();
          setIsPlaying(false);
        }
      } catch (error) {
        console.log("Video interaction error:", error);
      }
    }
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  // Get animation class based on selected type
  const getButtonClass = () => {
    switch (animationType) {
      case "pulse":
        return "play-button-pulse";
      case "glow":
        return "play-button-glow";
      case "bounce":
        return "play-button-bounce";
      case "ripple":
        return "play-button-ripple";
      case "color-shift":
        return "play-button-color-shift";
      case "fade":
        return "play-button-fade";
      default:
        return "play-button-pulse";
    }
  };

  // Get icon animation class
  const getIconClass = () => {
    return animationType === "spin" ? "play-icon-spin" : "";
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "relative",
        width: "100%",
        cursor: controls ? "default" : "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
          //transform: "scale(1.02)",
        },
        // Animation keyframes
        "@keyframes pulse": {
          "0%": {
            transform: "translate(-50%, -50%) scale(1)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
          "100%": {
            transform: "translate(-50%, -50%) scale(1.15)",
            backgroundColor: "rgba(30, 30, 30, 0.9)",
          },
        },
        "@keyframes glow": {
          "0%": {
            boxShadow: "0 0 0 0 rgba(255, 255, 255, 0.7)",
          },
          "70%": {
            boxShadow: "0 0 0 10px rgba(255, 255, 255, 0)",
          },
          "100%": {
            boxShadow: "0 0 0 0 rgba(255, 255, 255, 0)",
          },
        },
        "@keyframes spin": {
          "0%": {
            transform: "rotate(-15deg)",
          },
          "100%": {
            transform: "rotate(15deg)",
          },
        },
        "@keyframes ripple": {
          "0%": {
            transform: "scale(1)",
            opacity: 1,
          },
          "100%": {
            transform: "scale(1.4)",
            opacity: 0,
          },
        },
        "@keyframes bounce": {
          "0%": {
            transform: "translate(-50%, -50%) scale(1)",
          },
          "100%": {
            transform: "translate(-50%, -50%) scale(1.2)",
          },
        },
        "@keyframes colorShift": {
          "0%": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
          "50%": {
            backgroundColor: "rgba(40, 40, 40, 0.9)",
          },
          "100%": {
            backgroundColor: "rgba(80, 80, 80, 0.8)",
          },
        },
        "@keyframes fadeInOut": {
          "0%": {
            opacity: 0.7,
          },
          "100%": {
            opacity: 1,
          },
        },
      }}
      onClick={disableClick ? null : handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Box
        component="video"
        ref={videoRef}
        loop
        muted
        preload="auto"
        poster={poster}
        src={videoUrl}
        playsInline={true}
        controls={controls}
        autoPlay={autoPlay}
        alt="Instruktionsvideo"
        sx={{
          width: "100%",
          height: "auto",
          borderRadius: "10px",

          borderTopLeftRadius: gridDisplay ? "0px" : "10px",
          borderTopRightRadius: gridDisplay ? "0px" : "10px",

          borderBottomLeftRadius: horizDisplay ? "0px" : "10px",
          borderBottomRightRadius: horizDisplay ? "0px" : "10px",

          display: "block",
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        }}
      />
      {!controls && !autoPlay && !isPlaying && (
        <Box
          className={getButtonClass()}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: isPlaying ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
            pointerEvents: "none",
          }}
        >
          <PlayArrowIcon
            className={getIconClass()}
            sx={{
              color: "white",
              fontSize: "4rem",
              transition: "all 0.2s ease",
            }}
          />
        </Box>
      )}
    </Box>
  );
};
